<template>
  <div class="order-container">
    <div class="topTab">
      <!--      <div-->
      <!--        class="flex1"-->
      <!--        v-for="(s, i) in status"-->
      <!--        :key="i"-->
      <!--        @click="onChangeTab(s, i)"-->
      <!--      >-->
      <!--        <div :class="index === i ? 'isActive' : ''">{{ s.title }}</div>-->
      <!--      </div>-->
      <div class="flex1">
        <div class="timeBox">
          <div
            style="height: 44px;line-height: 44px; color: #000"
            v-if="query.startTime"
          >
            {{ query.startTime }}
          </div>
          <div style="height: 44px;line-height: 44px; color: #000" v-else>
            开始时间
          </div>
          <datetime
            class="dateInput"
            @on-change="startTimeChange"
            v-model="query.startTime"
          ></datetime>
        </div>
      </div>
      <div class="flex1">
        <div class="timeBox">
          <div
            style="height: 44px;line-height: 44px; color: #000"
            v-if="query.endTime"
          >
            {{ query.endTime }}
          </div>
          <div style="height: 44px;line-height: 44px; color: #000" v-else>
            结束时间
          </div>
          <datetime
            class="dateInput"
            @on-change="endTimeChange"
            v-model="query.endTime"
          ></datetime>
        </div>
      </div>
      <div class="flex1">
        <selector v-model="query.type" :options="searchList"></selector>
      </div>
      <div class="flex1">
        <selector
          @on-change="statusChange"
          v-model="query.status"
          :options="status"
        ></selector>
      </div>
    </div>
    <div class="flex tjBg">
      <div class="flex1">
        <div>总金额</div>
        <div v-if="amount">￥{{ amount }}元</div>
        <div v-else>￥0元</div>
      </div>
      <div class="flex1">
        <div>总笔数</div>
        <div>
          <div v-if="quantity">{{ quantity }}</div>
          <div v-else>0</div>
        </div>
      </div>
    </div>
    <!--    <div class="searchBox">-->
    <!--      <select v-model="query.type">-->
    <!--        <option-->
    <!--          :value="item.type"-->
    <!--          v-bind:key="item.value"-->
    <!--          v-for="item in searchList"-->
    <!--          >{{ item.value }}</option-->
    <!--        >-->
    <!--      </select>-->
    <!--      &lt;!&ndash;          <input&ndash;&gt;-->
    <!--      &lt;!&ndash;            class="searchInput"&ndash;&gt;-->
    <!--      &lt;!&ndash;            v-model="query.clientName"&ndash;&gt;-->
    <!--      &lt;!&ndash;            placeholder="客户名/公司名搜索"&ndash;&gt;-->
    <!--      &lt;!&ndash;          />&ndash;&gt;-->
    <!--      <div class="searchButton" @click="search">搜索</div>-->
    <!--    </div>-->

    <Scroller
      style="padding-bottom: 40px;"
      :style="{ height: scrollerHeight }"
      ref="scroll"
      :loadData="loadData"
      rowKey="id"
    >
      <template v-slot="{ item, i }">
        <div class="content">
          <!--          国内-->
          <div v-if="item.kind == 1" @click="$router.push('/order/' + item.id)">
            <div
              class="contentBox"
              v-for="goods in item.goodsDetails"
              :key="goods.id"
            >
              <div class="top vux-1px-b flex-between-center">
                <div>订单时间：{{ item.createTime | date }}</div>
                <div :style="{ color: statusDetail[item.status].color }">
                  {{ statusDetail[item.status].label }}
                </div>
              </div>
              <div class="middle flex vux-1px-b">
                <div class="imgBox">
                  <img :src="goods.image" />
                </div>
                <div class="flex1">
                  <div
                    class="title"
                    v-html="goods.name.replace(/(\r\n|\n|\r)/, '<br />')"
                  ></div>
                  <div class="spec">规格：{{ goods.volume }}</div>
                  <div class="money">
                    ￥
                    <span style="font-size: 16px">{{
                      goods.discountPrice
                    }}</span>
                    <span style="color: #919191;margin-left: 10px;"
                      >*{{ goods.quantity }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="bottom">
                <span class="buyerType" v-if="item.buyerType == 1">个人</span>
                <span class="buyerType" v-else>公司</span>
                <span class="tag" v-if="item.type == 2">预售</span>
                <span class="total">共{{ Number(goods.quantity) }}件商品</span>
                <span> </span>
              </div>
              <div class="bottom2">
                合计：
                <span style="color: #FF3600" class="total-price"
                  >￥{{ Number(goods.discountTotalPrice) }}</span
                >
              </div>
            </div>
          </div>
          <!--          国际-->
          <div v-else @click="$router.push('/intOrder/' + item.id)">
            <div class="contentBox">
              <div class="top vux-1px-b flex-between-center">
                <div>订单时间：{{ item.createTime | date }}</div>
                <div>订单已确认</div>
              </div>
              <div class="middle flex vux-1px-b">
                <div class="flex1">
                  <div class="title2">Commodity：
                    <span class="content">{{ item.intentionDetails.Commodity }}</span>
                  </div>
                  <div class="title2">
                    Quality：
                    <span class="content">{{ item.intentionDetails.Quality }}</span>
                  </div>
                  <div class="title2">
                    Price：<span class="content" >{{item.intentionDetails.Price}}</span>
                  </div>
                  <div class="title2">
                    Quantity：<span class="content">{{item.intentionDetails.Quantity}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Scroller>
  </div>
</template>
<script>
import { getOrderList, getStatistic } from "@/api/order";
import Scroller from "@/components/Scroller";
import { statusDetail } from "@/views/order/enum";
// import DatetimeView from "vux/src/components/datetime-view/index";

export default {
  components: { Scroller },
  name: "Order",
  data() {
    return {
      searchList: [
        {
          key: "0",
          value: "全部"
        },
        {
          key: "1",
          value: "个人"
        },
        {
          key: "2",
          value: "公司"
        }
      ],
      status: [
        {
          value: "全部",
          key: ""
        },
        {
          value: "待审核",
          key: "1"
        },
        {
          value: "跟进中",
          key: "3"
        },
        {
          value: "已完成",
          key: "100"
        },
        {
          value: "失效",
          key: "110"
        }
      ],
      loadData: params => {
        return getOrderList({ ...params, ...this.query });
      },
      index: 0,
      query: {
        status: "",
        type: 0,
        clientName: "",
        startTime: "",
        endTime: ""
      },
      amount: "",
      quantity: "",
      statusDetail
    };
  },
  watch: {
    "query.type"() {
      this.$refs["scroll"].getList(true);
      this.getStatistic();
    }
  },
  computed: {
    scrollerHeight: function() {
      return document.body.clientHeight - 89 - 53 + "px";
    }
  },
  created() {
    this.getStatistic();
  },
  mounted() {},
  methods: {
    getStatistic() {
      getStatistic(this.query)
        .then(res => {
          this.amount = res.amount;
          this.quantity = res.quantity;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    startTimeChange() {
      this.$refs["scroll"].getList(true);
      this.getStatistic();
    },
    endTimeChange() {
      this.$refs["scroll"].getList(true);
      this.getStatistic();
    },
    typeChange() {
      this.$refs["scroll"].getList(true);
      this.getStatistic();
    },
    statusChange() {
      this.$refs["scroll"].getList(true);
      this.getStatistic();
    },
    onChangeTab(status, i) {
      this.index = i;
      this.query.status = status.value;
      this.$refs["scroll"].getList(true);
    },
    search() {
      this.$refs["scroll"].getList(true);
    }
  }
};
</script>
<style scoped lang="less">
.title2 {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #525252;
}
.content {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: normal;
  color: #525252;
}
.tjBg {
  background: #fff;
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
  padding: 15px 0;
  text-align: center;
  font-size: 14px;
}
.timeBox {
  position: relative;
  height: 88px;
  line-height: 88px;
}
.timeBox div {
  height: 88px;
  line-height: 88px;
}
.dateInput {
  position: absolute;
  width: 100%;
  height: 88px;
  left: 0;
  top: 0;
  z-index: 1;
  opacity: 0;
  padding: 0;
}
.tag {
  float: left;
  margin-left: 20px;
  margin-top: 18px;
  background: #039df8;
  color: #fff;
  padding: 5px 10px;
  border-radius: 80px;
  display: inline-block;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.order-container {
  height: 100%;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.topTab {
  width: 100%;
  display: flex;
  /*position: fixed;*/
  /*top: 0;*/
  /*left: 0;*/
  /*z-index: 1;*/
  /*height: 88px;*/
  /*line-height: 88px;*/
  font-size: 14px;
  color: #515151;
  text-align: center;
  background: #fff;
}
.isActive {
  color: #379dfd;
  border-bottom: 1px solid #379dfd;
}
.content {
  overflow: hidden;
}
.contentBox {
  overflow: hidden;
  margin: 20px 28px;
  background: #fff;
  border-radius: 14px;
}
.top {
  height: 80px;
  line-height: 80px;
  padding: 0 30px;
  font-size: 13px;
  border-color: #efefef;
  color: rgb(171, 171, 171);
}
.middle {
  padding: 20px 30px;
  border-color: #efefef;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 12px;
  line-height: 32px;
  color: #525252;
}
.bottom {
  height: 88px;
  line-height: 88px;
  text-align: right;
  font-size: 12px;
  color: #535353;
  padding: 0 20px;
}
.bottom2 {
  height: 44px;
  line-height: 44px;
  text-align: right;
  font-size: 12px;
  color: #535353;
  padding: 10px 20px;
}
.total {
  /*margin-right: 18px;*/
}
.scroll-wrapper {
  overflow: hidden;
  position: relative;
  /*height: 100%;*/
  /*height: height;*/
}
.total-price {
  font-size: 15px;
}
.searchBox {
  width: 100%;
  /*height: 100px;*/
  overflow: hidden;
  background: #ffffff;
  color: #515151;
}

.searchBox select {
  background: #fff;
  border: none;
  outline: none;
  width: 100%;
  height: 88px;
  /*width: 160px;*/
  /*height: 60px;*/
  /*margin: 19px 0 19px 30px;*/
  /*border: 1px solid #e6e6e6;*/
  padding: 0 20px;
  text-align: center;
  text-align-last: center;
}
.searchInput {
  width: 300px;
  height: 60px;
  margin: 19px 30px;
  border: 1px solid #e6e6e6;
  background: #fff;
  padding: 0 20px;
}
.searchButton {
  font-size: 12px;
  float: right;
  width: 120px;
  margin: 20px 30px 20px 0;
  height: 60px;
  line-height: 60px;
  color: #fff;
  background: #039df8;
  text-align: center;
  border-radius: 10px;
}
.buyerType {
  float: left;
  color: #039df8;
}
.payType {
  float: left;
  color: #039df8;
}
.buyerTypeBtn {
  background: #5677fc;
  color: #fff;
  height: 53px;
  line-height: 2.2;
  padding: 0 22px;
  border-radius: 27px;
  box-shadow: 0 8px 12px #c5ccd7;
  margin: 17px 10px 0 10px;
}
.buyerTypeBtn2 {
  background: #d58a33;
  color: #fff;
  height: 53px;
  line-height: 2.2;
  padding: 0 22px;
  border-radius: 27px;
  box-shadow: 0 8px 12px #c5ccd7;
  margin: 17px 10px 0 10px;
}
</style>
